import { useState } from "react";
import { faqs, rules } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Guide() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="guide" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="讨论指南 · 玩得开心也玩得体面"
          title="让观点流动，也让秩序在场"
          desc="一群人说真话、也把话说得漂亮，是这里最好的状态。几条简单原则，帮你安心下场。"
          align="center"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {rules.map((r, i) => (
            <div
              key={r.title}
              className="rounded-2xl border border-background-200 bg-background-100 p-6 text-center"
            >
              <span
                className={`mx-auto flex h-11 w-11 items-center justify-center rounded-xl text-lg ${
                  i % 3 === 0
                    ? "bg-accent-100 text-accent-700"
                    : i % 3 === 1
                    ? "bg-primary-100 text-primary-700"
                    : "bg-secondary-100 text-secondary-800"
                }`}
              >
                <i className={r.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{r.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-10 max-w-3xl">
          <h3 className="text-center text-xl font-bold text-foreground-950 md:text-2xl">常见问题 FAQ</h3>
          <div className="mt-6 space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-xl border bg-background-100 transition-colors ${
                    open ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-transform ${
                        open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="border-t border-background-200 bg-background-50 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}